import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

export const addHospitalDepartment = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL}add-department`, data, headers);
};

export const hospitalDepartmentList = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}hospital-department-list`, data, headers);
};
export const updateDepartment = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL}update-department`, data, headers);
};
export const updateDepartmentStatus = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-department-status`,   data,  headers);
};
export const departmentDropDownList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}department-dropdown`,   data,  headers);
};
export const addSpecialization = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL}create-hospital-service`, data, headers);
};
export const updateSpecialization = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL}update-hospital-service`, data, headers);
};
export const SpecializationList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-service-list`,   data,  headers);
};
export const specializationDropDownList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-specialization-dropdown`,   data,  headers);
};
export const addHospitalDoctor = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-hospital-doctor`,   data,  headers);
};
export const addHospitalDoctorQualification = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-hospital-doctor-qualification`,   data,  headers);
};
export const hospitalDoctorList = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}hospital-doctor-list`,   data,  headers);
};
export const updateHospitalDoctor = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-hospital-doctor`,   data,  headers);
};
export const getHospitalDoctorQualification = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}get-hospital-doctor-qualification`,   data,  headers);
};
export const updateHospitalDoctorQualification = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-hospital-doctor-qualification`,   data,  headers);
};
export const hospitalDashboardAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}hospital-dashboard`,   data,  headers);
};
export const facilityAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-hospital-facility`,   data,  headers);
};
export const facilityListAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}hospital-facility-list`,   data,  headers);
};
export const CapacityAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-hospital-capacity`,   data,  headers);
};
export const CapacityListAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}hospital-capacity-list`,   data,  headers);
};
export const HospitalMachineAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-hospital-machine`,   data,  headers);
};
export const HospitalMachineListAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}hospital-machine-list`,   data,  headers);
};
export const UpdateHospitalFacility = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-hospital-facility`,   data,  headers);
};
export const UpdateHospitalServices = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-hospital-service`,   data,  headers);
};
export const UpdateHospitalMachines = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-hospital-machine`,   data,  headers);
};